<template>
  <div
    class="grid gap-8"
    :style="{
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`
    }"
  >
    <div
      v-for="item in list"
      :key="item.id"
      class="h-34 flex items-center"
      :class="[
        activeId === item.id ? 'bg-theme2 border-all-active' : 'bg-white border-all',
        cols === 3 ? ' justify-center' : 'justify-start'
      ]"
      @click="onClick(item)"
    >
      <div class="text-14 line-clamp-1" :class="activeId === item.id ? 'text-theme' : 'text-default'">
        {{ cols === 1 ? item.faulttype_type_name + " - " : "" }}{{ item.faulttype }}
      </div>
    </div>
  </div>
</template>
<script setup>
defineProps({
  activeId: String,
  list: Array,
  cols: {
    default: 3
  }
});
const emit = defineEmits(["select"]);
const onClick = item => emit("select", item);
</script>
